import React from 'lib/react';
import {
  EVAlert, EVGrid,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import ProductStyles from './ProductStyles';

function ThreeHourDeliveryMessage() {
  const classes = ProductStyles();
  const { t } = useTranslation();
  return (
    <EVGrid className={classes.alerts}>
      <EVAlert severity="info">{t('ThreeHourDeliveryMessage')}</EVAlert>
    </EVGrid>
  );
}

export default ThreeHourDeliveryMessage;
